import React from "react";
import Routers from "./routers";
import { AuthProvider } from "./hooks/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Global from "./global/global";
import { ConfigProvider } from "antd";
import ScrollToTop from "./components/ScrollTop";
import Chat from "./components/Chat";

function App() {
  return (
    <ConfigProvider
      pagination={{
        showSizeChanger: false,
        pageSize: 30,
      }}
      theme={{
        token: {
          // Seed Token
          colorPrimary: "#008037",
          colorPrimaryHover: "#333",
          borderRadius: 2,
          colorFill: "#008037",
          colorIcon: "#008037",
          colorBgContainer: "#fff",
        },
        components: {
          Button: {
            colorPrimary: "#008037",
            colorPrimaryHover: "#008037CC",
            boxShadow: 0,
            colorWarning: "#FF9900",
            colorWarningHover: "#FF9900CC",
          },
          Input: {
            lineWidthFocus: 1,
          },
        },
      }}
    >
      <ScrollToTop />
      <AuthProvider>
        <Routers />
        <Global />
      </AuthProvider>
      <ToastContainer autoClose={3000} theme="colored" />
    </ConfigProvider>
  );
}

export default App;
